<template>
  <Teleport to="body">
    <aside
      v-if="appState.estUtilisateurAuthentifie"
      class="right-sidebar"
      :class="{ 'right-sidebar--visible': isOpenMobileSidebarRight }"
      ref="sideBarRightRef"
    >
      <div class="right-sidebar__user-infos">
        <BasicText
          v-if="!estUtilisateurImpersonnalise"
          class="user-name"
          size="h5"
          weight="bold"
          focusable
          nb-max-lines="2"
        >
          {{ fullName }}
        </BasicText>
        <div
          v-else
          class="user-name-interne"
        >
          <BasicIcon
            name="profile"
            class="icon"
            active
            color="secondary-600"
          />
          <BasicText
            color="secondary-600"
            size="body-xl"
            weight="bold"
          >
            {{ fullNameInterne }}
          </BasicText>
        </div>
      </div>
      <hr />
      <div class="context-notif--container">
        <ComboContexte />
        <NotificationsComponent @update:model-value="onChildOpen">
          <template #trigger-notification="{ toggleNotifications, hasNotifications }">
            <BasicButton
              iconName="notification"
              @click="
                () => {
                  toggleNotifications()
                }
              "
              size="large"
            />
            <span
              v-if="hasNotifications"
              class="notifications__pastille"
            />
          </template>
        </NotificationsComponent>
      </div>
      <div
        v-if="!appState.estAuthentificationEnCours"
        class="right-sidebar__user-actions"
      >
        <BasicLink
          v-if="estUtilisateurImpersonnalise"
          label="Changer d’utilisateur externe"
          @link-click="changerUtilisateur"
          type="dark"
        />
        <BasicLink
          label="Accéder à mon profil"
          @link-click="redirectionProfil"
          type="dark"
        />
        <BasicLink
          label="Me rattacher à une entreprise"
          @link-click="demanderRattachement"
          type="dark"
        />
      </div>
      <div class="flex justify-content-center flex-1 align-items-flex-end">
        <BasicText
          size="body-m"
          color="neutral-500"
          @click="showCGU"
          pointer
          nb-max-lines="2"
        >
          Voir les conditions générales d'utilisation
        </BasicText>
      </div>
      <div class="flex justify-content-center flex-1 align-items-flex-end">
        <BasicButton
          @click="appState.deconnexionAsync"
          label="Se déconnecter"
        />
      </div>
    </aside>
  </Teleport>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { onMounted, ref, toRefs } from 'vue'
  import ComboContexte from '@/features/interface/layout/comboContexte/ComboContexte.vue'
  import NotificationsComponent from '@/features/interface/layout/notifications/NotificationsComponent.vue'
  import { useNavigationAction } from '@/features/interface/layout/header/useNavigationAction'
  import { useSidebarStateStore } from '@/features/interface/layout/sideBar/useSideBarStore'
  import { useHandleClickOutside } from '@/features/interface/composables/useHandleClickOutside'
  import { useAfficheCGU } from '@/features/interface/cgu/useAfficheCGU'

  const sideBarRightRef = ref<HTMLElement | null>(null)
  const appHeader = ref<HTMLElement | null>(null)

  const onClose = () => {
    closeMobileSidebar('right')
  }

  const { demanderRattachement, changerUtilisateur, redirectionProfil, fullName, fullNameInterne, appState } =
    useNavigationAction(onClose)

  const { estUtilisateurImpersonnalise } = toRefs(appState)

  const sidebarStateStore = useSidebarStateStore()

  const { closeMobileSidebar } = sidebarStateStore

  const { isOpenMobileSidebarRight } = storeToRefs(sidebarStateStore)

  const { pauseClickOutside } = useHandleClickOutside([sideBarRightRef, appHeader], onClose)

  let endPause: (() => void) | null = null
  const onChildOpen = (value: boolean | undefined) => {
    if (value) {
      pauseClickOutside(() => {
        return new Promise((resolve) => {
          endPause = resolve
        })
      })
    } else {
      endPause?.()
      endPause = null
    }
  }

  const showCGU = () => {
    const dialog = useAfficheCGU()
    dialog.showDialog({ validationObligatoire: false })
  }

  onMounted(() => {
    appHeader.value = document.getElementById('app-header')
  })
</script>

<style scoped lang="less">
  @import './SideBarRight.less';
</style>
